import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { useActionDispatcher } from '../../hooks';
import {
  getPromotionCodeRequest,
  resetCurrentPromotionCode,
  savePromotionCodeRequest,
} from '../../store/modules/promotion-codes/actions';
import PromotionCodeForm from './PromotionCodeForm';
import { selectPromotionCode } from '../../store/modules/promotion-codes/selectors';

const PromotionCodeEdit = () => {
  const dispatch = useDispatch();

  const promotionCode = useSelector(selectPromotionCode);

  const match = useRouteMatch<{ id: string }>()!;

  const promotionCodeId = promotionCode.data?.id;

  useEffect(() => {
    const matchId = parseInt(match.params.id, 10);
    if (!promotionCodeId || matchId !== promotionCodeId) {
      dispatch(getPromotionCodeRequest(matchId));
    }
  }, [dispatch, match.params.id, promotionCodeId]);

  useEffect(() => () => {
    dispatch(resetCurrentPromotionCode());
  }, [dispatch]);

  const savePromotionCode = useActionDispatcher(savePromotionCodeRequest);

  return (
    <PromotionCodeForm
      record={promotionCode}
      onSubmit={savePromotionCode}
    />
  );
};

export default PromotionCodeEdit;
